var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavCommercialIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.523,
    height: 20.75,
    viewBox: "0 0 24.523 20.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chart-line-up",
    d: "M48.523,59.807a.943.943,0,0,1-.943.943H24.943A.943.943,0,0,1,24,59.807V40.943a.943.943,0,0,1,1.886,0V53.757l5.935-5.936a.943.943,0,0,1,1.335,0l3.105,3.107,6.212-6.212H40.034a.943.943,0,1,1,0-1.886H44.75a.943.943,0,0,1,.943.943v4.716a.943.943,0,0,1-1.886,0V46.049l-6.878,6.879a.943.943,0,0,1-1.335,0l-3.105-3.107-6.6,6.6v2.439H47.579A.943.943,0,0,1,48.523,59.807Z",
    transform: "translate(-24 -40)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCommercialIcon);
export default __webpack_public_path__ + "static/media/Nav-CommercialIcon.93a7f3ac2f1207f557cdb3b750e7a38f.svg";
export { ForwardRef as ReactComponent };